export default __webpack_public_path__ + "static/media/Can you hear me now .452c76e7.mp3";